"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _lodash = require("lodash");

var _FormElementWrapper = _interopRequireDefault(require("../FormElementWrapper"));

var _MenuRenderer = _interopRequireDefault(require("./MenuRenderer"));

var _excluded = ["input", "isTree", "customLabel", "dictionary_id", "meta"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var waitOut = null;

var ComboBox = function ComboBox(props) {
  var input = props.input,
      isTree = props.isTree,
      customLabel = props.customLabel,
      dictionary_id = props.dictionary_id,
      meta = props.meta,
      rest = _objectWithoutProperties(props, _excluded);

  var labelKey = props.labelKey,
      valueKey = props.valueKey,
      isMulti = props.isMulti,
      options = props.options,
      className = props.className,
      plain = props.plain,
      asyncParams = props.asyncParams,
      fetchOptions = props.fetchOptions,
      defaultOptions = props.defaultOptions;

  var _useState = (0, _react.useState)(asyncParams),
      _useState2 = _slicedToArray(_useState, 2),
      asyncVals = _useState2[0],
      setAsyncVals = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      defOptions = _useState6[0],
      setDefOptions = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      touched = _useState10[0],
      setTouched = _useState10[1];

  var elTree = null;

  var findTree = function findTree(arr, val, key) {
    if ((0, _lodash.isArray)(arr)) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][key] === val) {
          elTree = arr[i];
          break;
        } else {
          findTree(arr[i].children, val, key);
        }
      }
    }
  };

  var getOption = function getOption(val) {
    if (!val) return null;
    var label = val.label,
        value = val.value;
    var opt = label && value ? val : {
      label: val[labelKey],
      value: val[valueKey]
    };
    return opt.value && opt.label ? opt : findOption(val) || null;
  };

  var findOption = function findOption(val) {
    var res = !(0, _lodash.isObject)(val) ? isTree ? findTree(options, val, valueKey) : options.find(function (v) {
      return v[valueKey] === val;
    }) : null;
    return getOption(res || elTree);
  };

  var setOption = function setOption(val) {
    var selected = !val || val === '' ? null : isMulti ? val.map(getOption) : getOption(val);
    setSelectedOption(selected);
    return selected;
  };

  var loadOptions = function loadOptions(query) {
    if (!defaultOptions) clearTimeout(waitOut);
    setIsLoading(true);
    return new Promise(function (resolve, reject) {
      waitOut = setTimeout(function () {
        var res = fetchOptions({
          asyncParams: asyncParams,
          query: query,
          dictionary_id: dictionary_id,
          labelKey: labelKey,
          valueKey: valueKey,
          customLabel: customLabel
        });
        setIsLoading(false);
        resolve(res);
      }, 400);
    });
  };

  var styles = {
    clearIndicator: function clearIndicator() {
      return {};
    },
    menu: function menu() {
      return {};
    },
    // menuList: () => ({}),
    container: function container() {
      return {};
    },
    control: function control() {
      return {};
    },
    option: function option() {
      return {};
    } // valueContainer: () => ({}),
    // singleValue: () => ({}),
    // placeholder: () => ({})

  };

  var onChange = function onChange(ops) {
    var selected = setOption(ops);
    return input && input.onChange && input.onChange(selected);
  };

  var onMenuClose = function onMenuClose() {// debugger;
  };

  var onFocus = function onFocus() {
    if (!defOptions && !defaultOptions && !!asyncParams) {
      loadOptions().then(function (resp) {
        return setDefOptions(resp);
      });
    }

    input.onFocus && input.onFocus();
  };

  var onBlur = function onBlur(e) {
    setTouched(true);
    e.preventDefault();
  };

  var treeProps = {
    MenuList: function MenuList(data) {
      return /*#__PURE__*/_react["default"].createElement(_MenuRenderer["default"], _extends({}, data, props, {
        value: input.value
      }));
    }
  };
  var Comp = asyncParams ? _async["default"] : _reactSelect["default"];

  var comboProps = _objectSpread(_objectSpread(_objectSpread({}, rest), input), {}, {
    touched: touched,
    components: isTree ? treeProps : {},
    className: "".concat(className, " ").concat(plain ? 'plain' : '', " ").concat(isTree ? 'tree' : ''),
    styles: styles,
    value: selectedOption,
    onChange: onChange,
    onBlur: onBlur,
    onMenuClose: onMenuClose,
    onFocus: onFocus,
    isLoading: isLoading,
    loadOptions: asyncParams ? loadOptions : function () {},
    defaultOptions: defOptions || defaultOptions
  });

  (0, _react.useEffect)(function () {
    setOption(input.value);
  }, [input.value]);
  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isEqual)(asyncParams, asyncVals)) {
      setAsyncVals(asyncParams);
      setDefOptions(null);
    }
  }, [asyncParams]);
  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], props, /*#__PURE__*/_react["default"].createElement(Comp, comboProps));
};

ComboBox.displayName = 'ComboBox';
ComboBox.propTypes = {
  input: _propTypes["default"].object,
  isAsync: _propTypes["default"].bool,
  isCreatable: _propTypes["default"].bool,
  hasExValue: _propTypes["default"].bool,
  isTree: _propTypes["default"].bool,
  isMulti: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  hasOnWheel: _propTypes["default"].bool,
  options: _propTypes["default"].array,
  getNode: _propTypes["default"].func,
  labelKey: _propTypes["default"].string,
  valueKey: _propTypes["default"].string,
  className: _propTypes["default"].string,
  plain: _propTypes["default"].bool,
  asyncParams: _propTypes["default"].object,
  fetchOptions: _propTypes["default"].func,
  defaultOptions: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].bool]),
  customLabel: _propTypes["default"].func,
  dictionary_id: _propTypes["default"].number
};
ComboBox.defaultProps = {
  hasExValue: false,
  isAsync: false,
  isCreatable: false,
  isTree: false,
  isMulti: false,
  label: '',
  required: false,
  hasOnWheel: true,
  options: [],
  getNode: null,
  labelKey: 'label',
  valueKey: 'value'
};
var _default = ComboBox;
exports["default"] = _default;